import React, { useState } from "react";
import styled from "styled-components";
import { AppDownload, Footer, Header } from "../components";
import {
  default as locationImages,
  default as locationTabs,
} from "../data/rushdata.json";

const LocationsPage = () => {
  const [tabsData] = useState(locationTabs.locationImageTabs);
  const [tabsImage] = useState(locationImages.loactionImage);
  const [toggletab, setToggleTab] = useState(0);

  const handleTabClick = (index) => {
    setToggleTab(index);
  };
  return (
    <>
      <Header />
      <Wrapper
        style={{ background: " #e5edfc", width: "100%", height: "481.55px" }}
        className="location_wrapper"
      >
        <div className="location section-center">
          <div className="location_row">
            <div className="location_header_h1">
              <h1>Our Locations</h1>
            </div>

            <div className="location_header_p">
              <p>
                Wecanrush is present in 5 cities and counting across the United
                States of America. Who knows? We may be coming to your city
                next,
              </p>
            </div>
          </div>
        </div>

        <svg
          className="location_svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="#E5EDFC"
            fill-opacity="1"
            d="M0,320L1440,64L1440,0L0,0Z"
          ></path>
        </svg>

        <div className="section-center location_image">
          <div className="location_image_wrapper">
            {tabsImage.map((element, index) => (
              <div
                className={
                  toggletab === index
                    ? "loaction_content active"
                    : "loaction_content"
                }
                key={element.id}
              >
                <img
                  className="location__img"
                  src={element.image}
                  alt="location"
                />
              </div>
            ))}
          </div>
          <div className="location_image_tabs">
            <div className="location_tabs_wrapper">
              {tabsData.map((element, index) => (
                <div
                  className={
                    toggletab === index
                      ? "location_tab active_loaction_tab"
                      : "location_tab"
                  }
                  key={element.id}
                  onClick={() => handleTabClick(index)}
                >
                  <span>{element.tabText}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  @media screen and (max-width: 768px) {
    .location_header_h1 {
      h1 {
        font-size: 36px !important;
      }
    }

    .location_header_p {
      p {
        font-size: 14px !important;
        width: 368px !important;
        color: #777e91;
      }
    }

    .location__img {
      width: 100% !important;
      height: 350 !important;
      margin: auto;
      object-fit: contain;
      padding: 14px;
    }
    .location_svg {
      margin-top: -30px;
    }
    .location_image {
      position: relative;
      top: -57% !important;
      padding: 0 0 63px 0;
    }
    .location_tab {
      padding: 13px 1px !important;
      span {
        font-size: 12px !important;
      }
    }

    .active_loaction_tab {
      padding: 13px 1px !important;
      span {
        font-size: 12px !important;
      }
    }

    /* .loaction_content {
      display: none;

      img {
        width: 100%;
        height: 100%;
        border-radius: 25px;
      }
    }

    .loaction_content.active {
      display: block;
    } */
  }

  .location_row {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
  }
  .location_header_h1 {
    padding: 0;
    h1 {
      font-family: Gilroy-Heavy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #6300ff;
      text-align: center;
    }
  }

  .location_header_p {
    padding: 0;
    p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 30px;
      width: 550px;
      margin-top: 20px;
      letter-spacing: 0.3px;
      display: block;
      text-align: center;
      color: #777e91;
    }
  }

  .location_image {
    position: relative;
    top: -87%;
  }

  .location_tabs_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .location_tab {
    cursor: pointer;
    padding: 13px 30px;
    border-bottom: 3px solid #5457770f;
    margin: 10px;
    span {
      font-family: Gilroy-Medium;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: #545777;
      padding: 12px 0px;
    }
  }
  .active_loaction_tab {
    cursor: pointer;
    border-bottom: 3px solid #2c5282;
    margin: 10px;
    span {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 15px;
      line-height: 18px;
      color: #2c5282;
      padding: 12px 0px;
    }
  }
  @media screen and (max-width: 440px) {
    .loaction_content {
      display: nobe;
      width: 100% !important;
      height: 100%;

      img {
        width: 100% !important;
        height: 100% !important;
        border-radius: 25px;
      }
    }

    .loaction_content.active {
      display: block;
      width: 100% !important;
      height: 100%;
    }

    .location_header_h1 {
      width: 100% !important;
      h1 {
        font-size: 36px !important;
        text-align: left !important;
        padding-left: 20px;
      }
    }

    .location_header_p {
      p {
        font-size: 16px !important;
        width: 368px !important;
        color: #777e91 !important;
        text-align: left !important;
        font-weight: 500 !important;
      }
    }

    .location__img {
      width: 100% !important;
      height: 350 !important;
      margin: auto;
      object-fit: contain;
      padding: 14px;
    }
    .location_svg {
      margin-top: 81px;
    }
    .location_image {
      position: relative;
      top: -49% !important;
    }
    .location_tab {
      padding: 13px 1px !important;
      span {
        font-size: 12px !important;
      }
    }

    .active_loaction_tab {
      padding: 13px 1px !important;
      span {
        font-size: 12px !important;
      }
    }
  }

  .location_row {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
  }
  .location_header_h1 {
    padding: 0;
    h1 {
      font-family: Gilroy-Heavy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #6300ff;
      text-align: center;
    }
  }

  .location_header_p {
    padding: 0;
    p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 30px;
      width: 550px;
      margin-top: 20px;
      letter-spacing: 0.3px;
      display: block;
      text-align: center;
      color: #777e91;
    }
  }

  .location_image {
    position: relative;
    top: -87%;
  }

  .location_tabs_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .location_tab {
    cursor: pointer;
    padding: 13px 30px;
    border-bottom: 3px solid #5457770f;
    margin: 10px;
    span {
      font-family: Gilroy-Medium;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: #545777;
      padding: 12px 0px;
    }
  }
  .active_loaction_tab {
    cursor: pointer;
    border-bottom: 3px solid #2c5282;
    margin: 10px;
    span {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 15px;
      line-height: 18px;
      color: #2c5282;
      padding: 12px 0px;
    }
  }

  .loaction_content {
    display: none;
    width: 1170px;
    height: 790px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 25px;
    }
  }
  /* .active_location_content {
    display: block;
    width: 1170px !important;
    height: 490px !important;
    img {
      width: 100% !important;
      height: 100% !important;
      border-radius: 25px;
    }
  } */

  .loaction_content.active {
    display: block;
  }

  .location_image_tabs {
    margin-bottom: -40%;
  }
`;

export default LocationsPage;
